import "./index.css";
import "./sentry_init";
import "./gtm_init";

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { LocalStorageConfigs, loadFromLocalWithFallback } from "./utils/LocalStorage";
import singleProcessReleaseReservation from "./V2/App/Actions/ReleaseReservation";

// Ensure global 'gmo' object exists to prevent ReferenceErrors from third-party scripts
// Introduced by iOS Chrome bug in 05-2025, no fix as of 10-2025
declare global {
  interface Window {
    gmo?: unknown;
  }
}
window.gmo = window.gmo || {};

const container = document.getElementById("root");

// Create a root.
if (!container) throw "Root could not be found.";
const root = createRoot(container);

// Initial render
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// if the user has a reservation and the environment is not local display a confirmation alert on page close
window.addEventListener("beforeunload", ev => {
  if (
    loadFromLocalWithFallback<unknown>(
      LocalStorageConfigs.reservation.key,
      LocalStorageConfigs.legacy.reservation.key
    ) &&
    process.env.REACT_APP_ENVNAME !== "Local"
  ) {
    ev.preventDefault();
    ev.returnValue = "Are you sure you want to exit? Your current reservation will be lost.";
    return "Are you sure you want to exit? Your current reservation will be lost.";
  }
});

window.addEventListener("unload", singleProcessReleaseReservation);
